// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* middle container */

.displayComponentHomePageMiddleContainer {
    background-color: var(--DarkBlue);
    width: 100%;
    display: flex;
    justify-content: center;
}

.displayComponentHomePageDescriptionTextContainer {
    display: flex;
    flex-direction: column;
    gap: 2em;
}

.displayComponentHomePageDescriptionTitleLegend {
    border: 3px solid var(--GrayBlue);
    border-radius: 5px;
    margin-left: 1em;
    padding: 0.2em 0.8em;
    color: white;
}

.displayComponentHomePageDescriptionTitleLegendRight {
    border: 3px solid var(--GrayBlue);
    border-radius: 5px;
    margin-right: 1em;
    text-align: right;
    padding: 0.2em 0.8em;
    color: white;
}

.displayComponentHomePageDescriptionTextCard {
    display: flex;
    flex-wrap: wrap;
    padding: 2em;
    gap: 2em;
}

.displayComponentHomePageDescriptionTextCardReverse {
    display: flex;
    flex-wrap: wrap-reverse;
    padding: 2em;
    gap: 2em;
}

.displayComponentHomePageDescriptionTextContainer p {
    font-size: 20px;
    max-width: 20em;
    text-align: left;
}

.displayComponentHomeMemeDisplayComponent {
    margin-left: auto;
    margin-right: auto;
    max-width: 12em;
    border-radius: 5px;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
}

.displayComponentHomePageDescriptionContainer {
    margin-left: auto;
    margin-right: auto;
    padding: 5em;
    max-width: 50em;
    position: relative;
    z-index: 1;
    animation: fadeInGlobal 2s;
}

.displayComponentHomePageDescriptionButtonInstall {
    padding-top: 4em;
    text-align: center;
}

@media only screen and (max-width: 901px) {
    .displayComponentHomePageDescriptionTextCard {
        justify-content: center;
    }

    .displayComponentHomePageDescriptionTextCardReverse {
        justify-content: center;
    }

    .displayComponentHomePageDescriptionTitleLegendRight {
        margin-left: auto;
        margin-right: auto;
    }

    .displayComponentHomePageDescriptionTitleLegend {
        margin-left: auto;
        margin-right: auto;
    }
}

@media only screen and (max-width: 540px) {
    .displayComponentHomePageDescriptionTextContainer p {
        font-size: 14px;
    }

    .displayComponentHomePageDescriptionTextContainer h1 {
        font-size: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/displayComponentHomePage/middleDisplay/middleDisplay.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,iCAAiC;IACjC,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* middle container */\n\n.displayComponentHomePageMiddleContainer {\n    background-color: var(--DarkBlue);\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.displayComponentHomePageDescriptionTextContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 2em;\n}\n\n.displayComponentHomePageDescriptionTitleLegend {\n    border: 3px solid var(--GrayBlue);\n    border-radius: 5px;\n    margin-left: 1em;\n    padding: 0.2em 0.8em;\n    color: white;\n}\n\n.displayComponentHomePageDescriptionTitleLegendRight {\n    border: 3px solid var(--GrayBlue);\n    border-radius: 5px;\n    margin-right: 1em;\n    text-align: right;\n    padding: 0.2em 0.8em;\n    color: white;\n}\n\n.displayComponentHomePageDescriptionTextCard {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 2em;\n    gap: 2em;\n}\n\n.displayComponentHomePageDescriptionTextCardReverse {\n    display: flex;\n    flex-wrap: wrap-reverse;\n    padding: 2em;\n    gap: 2em;\n}\n\n.displayComponentHomePageDescriptionTextContainer p {\n    font-size: 20px;\n    max-width: 20em;\n    text-align: left;\n}\n\n.displayComponentHomeMemeDisplayComponent {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 12em;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n}\n\n.displayComponentHomePageDescriptionContainer {\n    margin-left: auto;\n    margin-right: auto;\n    padding: 5em;\n    max-width: 50em;\n    position: relative;\n    z-index: 1;\n    animation: fadeInGlobal 2s;\n}\n\n.displayComponentHomePageDescriptionButtonInstall {\n    padding-top: 4em;\n    text-align: center;\n}\n\n@media only screen and (max-width: 901px) {\n    .displayComponentHomePageDescriptionTextCard {\n        justify-content: center;\n    }\n\n    .displayComponentHomePageDescriptionTextCardReverse {\n        justify-content: center;\n    }\n\n    .displayComponentHomePageDescriptionTitleLegendRight {\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .displayComponentHomePageDescriptionTitleLegend {\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n\n@media only screen and (max-width: 540px) {\n    .displayComponentHomePageDescriptionTextContainer p {\n        font-size: 14px;\n    }\n\n    .displayComponentHomePageDescriptionTextContainer h1 {\n        font-size: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
